var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChargesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.21505 17.381L10.2432 14.3464L14.142 17.863V2.77523C14.142 1.59893 13.1851 0.642021 12.0081 0.642021H0.288086V17.8617L4.18966 14.3464L7.21505 17.381ZM3.19766 3.93483H11.2331V5.09308H3.19766V3.93483ZM3.19766 6.50443H11.2331V7.66267H3.19766V6.50443ZM3.19766 9.07198H8.82263V10.2302H3.19766V9.07198Z",
    fill: "#4079F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChargesIcon);
export default __webpack_public_path__ + "static/media/charges-icon.9d04b840a038a544d63894ab3aa8f2fc.svg";
export { ForwardRef as ReactComponent };